import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var DocumentFileTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(DocumentFileTransformer, _BaseTransformer);
  var _super = _createSuper(DocumentFileTransformer);
  function DocumentFileTransformer() {
    _classCallCheck(this, DocumentFileTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(DocumentFileTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        category: data.category ? data.category.value : null,
        categoryLabel: data.category ? data.category.label : null,
        documentName: data.document_name,
        file: data.document_file,
        storage: data.storage,
        accountName: data.account_name ? data.account_name.value : null,
        accountNameLabel: data.account_name ? data.account_name.label : '',
        project: data.project ? data.project.value : null,
        projectLabel: data.project ? data.project.label : null,
        deal: data.deal ? data.deal.value : null,
        dealLabel: data.deal ? data.deal.label : null,
        contract: data.contract ? data.contract.value : null,
        contractLabel: data.contract ? data.contract.label : null,
        recordOwner: data.record_owner,
        labels: data.labels,
        createdOn: data.created_on,
        createdBy: data.created_by,
        lastModifiedOn: data.last_modified_on,
        lastModifiedBy: data.last_modified_by,
        lastRevisedBy: data.last_revised_by,
        lastRevisedDate: data.last_revision_date,
        versionNo: data.version_no,
        recordId: data.record_id
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return DocumentFileTransformer;
}(BaseTransformer);